module.exports = __webpack_public_path__ + "static/img/stay-option-icon-sauna.d41d8cd9.svg";